<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="9">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="3" v-if="1 == 2">
        <div class="form-group form-actions float-right pb-2">
          <b-button
            class="mr-2"
            type="submit"
            size="md"
            variant="primary"
            @click="newUser"
          >
            <i class="fa fa-user-plus"></i>
            New User
          </b-button>
        </div>
        <div>
          <StyledDialog
            @filterList="filterList"
            :CurrentObject="mySelected"
            EntityType="N_User"
          >
            <div slot="header">
              <h2>{{ mySelected.FirstName }} {{ mySelected.LastName }}</h2>
            </div>
            <div slot="details">
              <div>{{ mySelected.Title }}</div>
              <div>{{ mySelected.Email1 }}</div>
            </div>
            <span slot="entityType">User</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <!-- <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template> -->
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRows"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "MyUserListSubset",
  data: () => {
    return {
      fields: [
        {
          key: "UserName",
          label: "UserName",
          sortable: true,
          thStyle: "width: 35%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "FirstName",
          label: "First",
          sortable: true,
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "LastName",
          label: "Last",
          sortable: true,
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "Phone1",
          label: "Phone",
          sortable: true,
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "MemberOf.UserGroupName",
          label: "Group",
          sortable: true,
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: ""
    };
  },
  props: {
    group_object: { type: Object }
  },
  components: {
    cTable,
    StyledDialog
    //MyBaseTable
  },
  mounted() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.n_user.n_users.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["n_user", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    async myLoadComponent() {
      await this.$store.dispatch("n_user/fetchUserGroups");
      await this.$store.dispatch("n_user/fetchUsers");
      this.filterList();
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$store
        .dispatch("n_user/loadUserEdit", record.UserProfileID)
        .then(() => {
          this.$router.push({ name: "User" });
        });
    },
    newUser() {
      this.$store
        .dispatch("n_user/New")
        .then(() => {
          this.$router.push({
            name: "User"
            //,
            //params: { id: this.event.id }
          });
        })
        .catch(() => {
          console.log("There was a problem");
        });
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.n_user.n_users.filter(
        user => user.MemberOf.UserGroupID == this.group_object.UserGroupID
      );

      this.filteredObjects = this.filteredObjects.filter(
        user =>
          user.FirstName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          user.LastName.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          user.UserName.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          user.Address1.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          user.City.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          user.State.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          user.Zip.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          user.MemberOf.UserGroupName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshUserObject() {
      return {
        id: -1,
        UserName: "New User",
        FirstName: "Test",
        MemberOf: {
          UserGroupID: -5
        }
      };
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
